import { render, staticRenderFns } from "./ChartD.vue?vue&type=template&id=c4573270&scoped=true"
import script from "./ChartD.vue?vue&type=script&lang=js"
export * from "./ChartD.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4573270",
  null
  
)

export default component.exports